import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { EffectivePolicySettingsDialogComponent } from "../effective-policy-settings-dialog/effective-policy-settings-dialog.component";
import { Platform } from "src/app/models/api";
import { EffectivePolicySettingEnum } from "src/app/services/infra/store/model/effectivePolicySetting.model";

@Component({
    selector: "app-effective-policy-settings-button",
    templateUrl: "./effective-policy-settings-button.component.html",
    styleUrls: ["./effective-policy-settings-button.component.scss"],
})
export class EffectivePolicySettingsButtonComponent {
    @Input() public effectivePolicySetting: EffectivePolicySettingEnum;
    @Input() public platform: Platform;
    @Output() public buttonClickedEventEmitter: EventEmitter<undefined> = new EventEmitter<undefined>();

    constructor(private _matDialog: MatDialog) {}

    public buttonClicked() {
        this.buttonClickedEventEmitter.emit();
        this._openEffectivePolicySettingsDialog(this.effectivePolicySetting, this.platform);
    }

    private _openEffectivePolicySettingsDialog(effectivePolicySettingName: EffectivePolicySettingEnum, platform: Platform) {
        this._matDialog.open(EffectivePolicySettingsDialogComponent, {
            data: {
                effectivePolicySettingName: effectivePolicySettingName,
                platform: platform,
            },
            disableClose: false,
            panelClass: "sized-popup-dialog-container",
            width: "800px",
            maxHeight: "90vh",
        });
    }
}
